import { Routes, Route, useLocation } from "react-router-dom";
import { lazy, Suspense, useEffect, useLayoutEffect, useRef } from 'react';
import { createPortal } from "react-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";

const Contact = lazy(() => import("./pages/contact"));
const About = lazy(() => import("./pages/about"));
const TheFilm = lazy(() => import("./pages/the-film"));
const TheBook = lazy(() => import("./pages/the-book"));
const FunTrivia = lazy(() => import("./pages/Fun-Trivia.jsx"));
const Awards = lazy(() => import("./pages/awards.jsx"));

const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Ghosted MD",
  url: "https://ghostedmd.com/",
  logo: "https://ghostedmd.com/favicon.png",
};

function App() {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const headerSlot = document.getElementById("header-slot");
  const lcpHeroRef = useRef(null);

  document.documentElement.classList.toggle("is-home", isHome);

  useLayoutEffect(() => {
    document.getElementById("static-logo")?.remove();
  }, []);

  useLayoutEffect(() => {
    const root = document.getElementById("root");
    if (!lcpHeroRef.current) {
      lcpHeroRef.current = document.getElementById("lcp-hero");
    }
    const hero = lcpHeroRef.current;
    if (!hero || !root) return;

    if (isHome) {
      if (!hero.isConnected) root.before(hero);
    } else if (hero.isConnected) {
      hero.remove();
    }
  }, [isHome]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    const pathClass = location.pathname.replace(/\//g, '') || 'home';
    document.body.className = '';
    document.body.classList.add(`page-${pathClass}`);
  }, [location.pathname]);
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(organizationJsonLd),
        }}
      />
      {headerSlot ? createPortal(<Header />, headerSlot) : <Header />}
      <main>
        <Suspense fallback={<div className="page-width" style={{ minHeight: "50vh" }} />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/the-film" element={<TheFilm />} />
            <Route path="/the-book" element={<TheBook />} />
            <Route path="/fun-trivia" element={<FunTrivia />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/awards" element={<Awards />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </>
  );
}

export default App;
